import { c as _c } from "react/compiler-runtime";
import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import { useMemo } from "react";
import { useAppConfig } from "./config";
import type { AdminPaths } from "./api/admin-types";
export function useFetchClient() {
  const $ = _c(2);
  const config = useAppConfig();
  let t0;
  if ($[0] !== config.apiUrl) {
    t0 = createFetchClient({
      baseUrl: config.apiUrl,
      credentials: "include"
    });
    $[0] = config.apiUrl;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function useApi() {
  const $ = _c(2);
  const fetchClient = useFetchClient();
  let t0;
  if ($[0] !== fetchClient) {
    t0 = createClient(fetchClient);
    $[0] = fetchClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}